import {
  RESET_INSIGHTS,
  RESET_INSIGHT,
  RESET_ERROR,
  GET_INSIGHTS,
  SET_INSIGHTS,
  API_ERROR,
  GET_INSIGHT,
  SET_INSIGHT,
  EDIT_INSIGHT,
  EDIT_INSIGHT_SUCCESS,
  CREATE_INSIGHT,
  CREATE_INSIGHT_SUCCESS,
  DELETE_INSIGHT,
  DELETE_INSIGHT_SUCCESS,
} from "./actionTypes";

export const resetInsights = () => {
  return {
    type: RESET_INSIGHTS,
    payload: {},
  };
};

export const resetInsight = () => {
  return {
    type: RESET_INSIGHT,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getInsights = (page, qnt, name, idCompany, isForm) => {
  return {
    type: GET_INSIGHTS,
    payload: { idCompany, page, qnt, name, isForm },
  };
};
export const setInsights = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_INSIGHTS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createInsight = (newFields) => {
  return {
    type: CREATE_INSIGHT,
    payload: { newFields },
  };
};
export const createInsightSuccess = (message) => {
  return {
    type: CREATE_INSIGHT_SUCCESS,
    payload: { message },
  };
};

export const getInsight = (idInsight) => {
  return {
    type: GET_INSIGHT,
    payload: { idInsight },
  };
};
export const setInsight = (data) => {
  return {
    type: SET_INSIGHT,
    payload: { data },
  };
};

export const editInsight = (idInsight, newFields) => {
  return {
    type: EDIT_INSIGHT,
    payload: { idInsight, newFields },
  };
};
export const editInsightSuccess = (message) => {
  return {
    type: EDIT_INSIGHT_SUCCESS,
    payload: { message },
  };
};

export const deleteInsight = (idInsight) => {
  return {
    type: DELETE_INSIGHT,
    payload: { idInsight },
  };
};
export const deleteInsightSuccess = (message) => {
  return {
    type: DELETE_INSIGHT_SUCCESS,
    payload: { message },
  };
};
